import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async findEnderecoIterpa ({ commit }, id) {
    const endereco = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findEnderecoById',
      params: {
        id
      }
    })
    return endereco
  },

  async findEnderecoByCep ({ commit }, cep) {
    if (cep === '' || cep === null || cep.length !== 9) return
    const cepLimpo = cep.replace(/\D/g, '')

    const endereco = await axios({
      method: 'get',
      url: `https://viacep.com.br/ws/${cepLimpo}/json/`,
      loaderText: 'Procurando endereço...'
    })
    return endereco
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/endereco.js